export default __webpack_public_path__ + "static/media/CIRT.65507b2b.png";